<template>
  <div>
    <!-- key attribute forces component to reload
       https://github.com/vuejs/vue-router/issues/1490#issuecomment-306029174
    -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style>

.form-label {
  margin-bottom:5px;
}
.form-label label{
  font-family: Tahoma;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.04em;
  /* black / 64 */
  color: rgba(0, 0, 0, 0.84);
}
.form-input {
  width: 100%;
}

.tbl-label {
  font-family: Tahoma;
  font-style: normal;
  font-size: 11px;
  line-height: 16px;

  /* or 145% */
  text-align: center;
  letter-spacing: 0.04em;

  /* black / 80 */
  color: rgba(0, 0, 0, 0.8);

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  align-self: center;
  padding: 3px;
}

.tbl-value {
  text-align: center;
  vertical-align: middle;
  padding: 3px 5px;

  font-family: Tahoma;
  font-style: normal;
  font-size: 12px;
  line-height: 14px;
}
</style>
